import React, { ReactNode, SyntheticEvent } from 'react';
import cx from 'classnames';

import { LoadingSpinner } from '../../..';

import { HEIGHTS, TOP_PADDING_MAP, WIDTHS } from '../constants';

interface Props {
    children: ReactNode;
    collapsedHeaderPadding?: TopPadding;
    mainContentId: string;
    mainWidth?: string | number | null;
    loading: boolean;
    scrollState: ScrollState;
    setScrollState(state: ScrollState): void;
    topPadding?: TopPadding;
}

export const LeftNavMainContent = ({
    children,
    collapsedHeaderPadding,
    mainContentId,
    mainWidth = WIDTHS.MAIN_XL,
    loading = false,
    setScrollState,
    scrollState,
    topPadding,
}: Props): JSX.Element => {
    let mainTopPadding = 0;

    if (topPadding !== undefined) {
        mainTopPadding = TOP_PADDING_MAP[topPadding];
    }

    return (
        <main
            id={mainContentId}
            className="w-full flex flex-col flex-grow overflow-x-hidden overflow-y-auto items-start relative"
            style={{
                paddingLeft: WIDTHS.LEFT_NAV,
            }}
            onScroll={(e: SyntheticEvent): void => {
                if (collapsedHeaderPadding) {
                    const target = e.target as Element;
                    const scrollTop = target?.scrollTop ?? 0;

                    if (
                        scrollTop > HEIGHTS.HEADER_SCROLL_THRESHOLD &&
                        scrollState === 'up'
                    ) {
                        setScrollState('down');
                    } else if (
                        scrollTop <= HEIGHTS.HEADER_SCROLL_THRESHOLD &&
                        scrollState === 'down'
                    ) {
                        setScrollState('up');
                    }
                }
            }}
        >
            {loading && (
                <div
                    className={cx(
                        'h-full flex-none flex justify-center items-center',
                        {
                            'w-full': mainWidth === null,
                        },
                    )}
                    style={{
                        width: mainWidth ?? undefined,
                    }}
                >
                    <LoadingSpinner />
                </div>
            )}
            {!loading && (
                <div
                    style={{
                        width: mainWidth ?? undefined,
                        paddingTop: mainTopPadding,
                        marginLeft: WIDTHS.MAIN_LEFT_MARGIN,
                        marginRight: WIDTHS.MAIN_RIGHT_MARGIN,
                    }}
                >
                    {children}
                </div>
            )}
        </main>
    );
};
